import React from 'react';
import { TablePagination } from '@mui/material';
import { useIntl } from 'react-intl';
import TablePaginationActions from './TablePaginationActions';

export interface IProps {
  id?: number;
  label?: string;
  page: number;
  realPerPage?: number;
  perPage: number;
  total: number;
  fetchRows?: any;
  statuses?: string;
  companyId?: string;
  rowsPerPageOptions?: number[];
}

const TablePaginator: React.FC<IProps> = ({
  id,
  label,
  page,
  realPerPage,
  perPage,
  total,
  fetchRows,
  statuses,
  companyId,
  rowsPerPageOptions = [10, 20, 50],
}) => {
  const intl = useIntl();

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (id) {
      fetchRows({ page: newPage + 1, perPage, categoryId: id });
    } else if (statuses) {
      fetchRows({ page: newPage + 1, perPage, statuses });
    } else if (companyId) {
      fetchRows({ page: newPage + 1, perPage, companyId });
    } else {
      fetchRows({ page: newPage + 1, perPage });
    }
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (id) {
      fetchRows({ page: 1, perPage: parseInt(event.target.value, 10), categoryId: id });
    } else if (statuses) {
      fetchRows({ page: 1, perPage: parseInt(event.target.value, 10), statuses });
    } else if (companyId) {
      fetchRows({ page: 1, perPage: parseInt(event.target.value, 10), companyId });
    } else {
      fetchRows({ page: 1, perPage: parseInt(event.target.value, 10) });
    }
  };

  return (
    <TablePagination
      onChange={() => {}}
      rowsPerPageOptions={rowsPerPageOptions}
      count={total}
      rowsPerPage={perPage}
      page={page - 1}
      labelRowsPerPage={
        <div 
          style={{
          display:'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          marginTop: 10
          }}>
            {label}
        </div>
      }
      slotProps={{
        select: {
          inputProps: { 'aria-label': 'first page' },
          native: true
        },
      }}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      ActionsComponent={TablePaginationActions}
      labelDisplayedRows={({ from, to, count }) => (
        <div style={{
          display:'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          marginTop: 11
        }}>
          {`${from}${realPerPage === 1 ? '' : '-'}${
            realPerPage === 1 ? '' : to
          } ${intl.formatMessage({
            id: 'TABLE.FROM.LABEL',
          })} ${count}`}
        </div>
      )}
    />
  );
};

export default TablePaginator;
